import { render, staticRenderFns } from "./TypesList.vue?vue&type=template&id=27d5aa97&scoped=true"
import script from "./TypesList.vue?vue&type=script&lang=js"
export * from "./TypesList.vue?vue&type=script&lang=js"
import style0 from "./TypesList.vue?vue&type=style&index=0&id=27d5aa97&prod&lang=scss&scoped=true"
import style1 from "./TypesList.vue?vue&type=style&index=1&id=27d5aa97&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d5aa97",
  null
  
)

export default component.exports